import { render, staticRenderFns } from "./PrefixSelect.vue?vue&type=template&id=3a3f7dbc"
import script from "./PrefixSelect.vue?vue&type=script&lang=js"
export * from "./PrefixSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports